import {
  buildRegionFilterModel,
  listJurisdictionRegions,
} from "@/hera-api/regions-api";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export function useRegionFilterOptions({
  jurisdictionIds,
  jurisdictionNames,
  enabled,
}: {
  jurisdictionIds: string[];
  jurisdictionNames: Record<string, string>;
  enabled: boolean;
}) {
  const query = useQuery({
    queryKey: ["jurisdiction-regions", jurisdictionIds],
    queryFn: () => listJurisdictionRegions(jurisdictionIds),
    enabled: enabled && jurisdictionIds.length > 0,
  });
  return useMemo(
    () => buildRegionFilterModel(query.data?.regions ?? [], jurisdictionNames),
    [jurisdictionNames, query.data?.regions],
  );
}
